import {endpoints} from "~/network/endpoints.js";
import {useHttpRequest} from "~/composables/useHttpRequest";

/**
 * Team handicaps API (HANDICAPS_PLAN.md). The server renders EVERY label and pick-list
 * (scheme.options / stepOptions / pacePresets / kOptions), so nothing here knows a sport.
 *
 *   GET  api/v2/handicapsettings?ladderId=|leagueId=|tournamentId=|americanoId=   → settings | null (204)
 *   PUT  api/v2/handicapsettings                                                    → settings | null
 *   GET  api/v2/handicapschemes?sportId=|sportName=                                → [scheme]
 *   POST api/v2/handicapschemes/preview                                            → {start, adjustment}
 *   GET  api/v2/handicapChanges?filters...                                         → paged history
 *   POST api/v2/handicapChanges                                                    → change (admin set)
 *   POST api/v2/handicapChanges/batch                                              → [change] (bulk admin set)
 */
export function useHandicapApi() {
  const {httpRequest} = useHttpRequest();

  // httpRequest returns null for a 204 (no body) — "handicaps off"
  const getSettings = async (scope) => {
    const res = await httpRequest(endpoints.handicapSettings.get, scope);
    return res && res.id ? res : null;
  };

  const setSettings = async (payload) => {
    const res = await httpRequest(endpoints.handicapSettings.set, payload);
    return res && res.id ? res : null;
  };

  const getSchemes = (query) => httpRequest(endpoints.handicapSchemes.list, query);

  // {homeTeamId, awayTeamId, leagueCycleDivisionId | tournamentStageId | americanoCycleDivisionId} → HandicapStart | null
  const getPairingStart = async (query) => {
    const res = await httpRequest(endpoints.handicapSettings.start, query);
    return res && res.summary != null ? res : null;
  };

  const preview = (payload) => httpRequest(endpoints.handicapSchemes.preview, payload);

  const listChanges = (filters, page = 1, limit = 20) =>
      httpRequest(endpoints.handicapChanges.getItems, {filters, page, limit});

  const setHandicap = (payload) => httpRequest(endpoints.handicapChanges.addItem, payload);

  // "Set handicaps" dialog: one scope, many {teamId, playerId, newValue}; returns the rows written
  const setHandicaps = (payload) => httpRequest(endpoints.handicapChanges.batch, payload);

  return {getSettings, setSettings, getSchemes, getPairingStart, preview, listChanges, setHandicap, setHandicaps};
}
